import { Component, OnInit, ViewChild, Input, AfterViewInit, ElementRef } from '@angular/core';
import { SignaturePad } from 'angular2-signaturepad';

@Component({
  selector: 'custom-signature-pad',
  templateUrl: './signature-pad.component.html',
  styleUrls: ['./signature-pad.component.scss']
})
export class SignaturePadComponent implements OnInit,AfterViewInit {
  
  @ViewChild("signaturePad") signaturePad : SignaturePad
  @ViewChild("signatureBody") signatureBody : ElementRef

  signaturePadOptions: Object = { // passed through to signature_pad constructor
    'minWidth': 5,
  };

  constructor() { }

  @Input() signature: string;

  ngOnInit() {

    this.signaturePad.onEndEvent.subscribe(() => this.saveSignature());

  }

  ngAfterViewInit() {
    let width = document.getElementsByClassName("m-signature-pad--body") && document.getElementsByClassName("m-signature-pad--body")[0].clientWidth;
    let height = document.getElementsByClassName("m-signature-pad--body") && document.getElementsByClassName("m-signature-pad--body")[0].clientHeight;
    let canvas = document.querySelector('canvas');

    canvas && (canvas.height = height);
    canvas && (canvas.width = width);
    try{
    this.signaturePad && this.signaturePad.set('canvasWidth',width);
    this.signaturePad && this.signaturePad.set('canvasHeight',height);
    }
    catch(e){

    }
    
  }

  clear() {

    this.signaturePad.clear();
    this.signature = "";

  }

  saveSignature() {

    this.signature = this.signaturePad.toDataURL('image/svg',0.5);
    console.log(this.signature);
  
  }
}
